export default function Separator() {
    return <div className='w-full border-t bg-accent-dark'></div>;
}
